import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import React from 'react';
import { Simplify } from 'type-fest';

import { omit } from '../../api/apiTypes.shim';

export type ButtonProps = Simplify<
  Omit<MuiButtonProps, 'children'> & ({ children: MuiButtonProps['children'] } | { text: string })
>;

export const Button = (props: ButtonProps) => {
  const children = 'text' in props ? <>{props.text}</> : props.children;
  return <MuiButton {...omit(props, ['text', 'children'])}>{children}</MuiButton>;
};
